import React, { useEffect, useState } from "react";
import axiosClient from "../../axios";
import SideBar from "../SideBar";
import MonthSelector from "./MonthSelector";
import KPICards from "./KPICards";
import TopPartnersTable from "./TopPartnersTable";
import ChartsSection from "./ChartsSection";
import OutstandingPaymentsTable from "./OutstandingPaymentsTable";
import AllPartnersModal from "./AllPartnersModal";
import "../../assets/css/AdminCommon.css";

const FinancialDashboard = () => {
	const [selectedMonth, setSelectedMonth] = useState(() => {
		const now = new Date();
		const year = now.getFullYear();
		const month = String(now.getMonth() + 1).padStart(2, "0");
		return `${year}-${month}`;
	});
	
	const [dashboardData, setDashboardData] = useState(null);
	const [outstandingData, setOutstandingData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [allPartnersModalOpen, setAllPartnersModalOpen] = useState(false);

	// Fetch monthly summary
	const fetchMonthlySummary = () => {
		setLoading(true);
		axiosClient
			.get(`/admin/monthly-summary?month=${selectedMonth}`)
			.then((res) => {
				setDashboardData(res?.data?.response || null);
			})
			.catch((err) => {
				console.log("error fetching monthly summary", err);
				alert("Error fetching dashboard data");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	// Fetch outstanding payments
	const fetchOutstandingPayments = () => {
		const today = new Date().toISOString().split('T')[0];
		axiosClient
			.get(`/admin/outstanding-payments?asOfDate=${today}`)
			.then((res) => {
				setOutstandingData(res?.data?.response || null);
			})
			.catch((err) => {
				console.log("error fetching outstanding payments", err);
			});
	};

	useEffect(() => {
		fetchMonthlySummary();
	}, [selectedMonth]);

	useEffect(() => {
		fetchOutstandingPayments();
	}, []);

	return (
		<>
			<SideBar handleSideBar={true} activeTab={"Finance"} />
			<div className="admin-screen-v4">
				{/* HEADER */}
				<div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
					<div className="admin-header-v4">
						<div>
							<h2>Financial Dashboard</h2>
							<p style={{ margin: "8px 0 0 0", color: "var(--text-muted)", fontSize: "14px" }}>
								Revenue, payments, and partner performance
							</p>
						</div>
						<MonthSelector selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} />
					</div>
				</div>

				{loading ? (
					<div className="loader-container-v4">
						<div className="loader-image-v4">📊</div>
						<p style={{ marginTop: "var(--spacing-md)", color: "var(--text-muted)" }}>
							Loading dashboard...
						</p>
					</div>
				) : dashboardData ? (
					<>
						{/* LEVEL 1: KPI CARDS */}
						<div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
							<KPICards kpis={dashboardData.kpis} />
						</div>

						{/* LEVEL 2: TOP PARTNERS + CHARTS */}
						<div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
							<TopPartnersTable 
								partners={dashboardData.topPartners} 
								onViewAll={() => setAllPartnersModalOpen(true)}
							/>
						</div>

						<div className="admin-form-container-v4" style={{ marginBottom: "var(--spacing-xl)" }}>
							<ChartsSection chartData={dashboardData.chartData} />
						</div>

						{/* LEVEL 3: OUTSTANDING PAYMENTS */}
						{outstandingData && outstandingData.outstandingPayments?.length > 0 && (
							<div className="admin-form-container-v4">
								<OutstandingPaymentsTable outstandingData={outstandingData} />
							</div>
						)}
					</>
				) : (
					<div className="empty-state-v4">
						<div className="empty-icon-v4">📭</div>
						<h3>No Data Available</h3>
						<p>No financial data found for the selected month</p>
					</div>
				)}
			</div>

			{/* ALL PARTNERS MODAL */}
			<AllPartnersModal
				open={allPartnersModalOpen}
				onClose={() => setAllPartnersModalOpen(false)}
				month={selectedMonth}
			/>
		</>
	);
};

export default FinancialDashboard;